import { HttpError } from "./HttpError";

/** Error HTTP 404 (recurso no encontrado). */
export class NotFoundError extends HttpError {
  /** @param message Mensaje de error. */
  constructor(message: string) {
    super(message, 404);
  }
}
